// import { useEffect } from "react";
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
// import ValidationText from '../../../../../../../../../EHR Settings/Templates/OpenTemplate/FormBuilder/Items/ValidationText';
import DatePicker from '../../../../../../../../../General/DatePicker';
import ShowItemContent from './ShowItemContent';

const Date = ({ item, setItem, activeAccordion, validations, isGroupNote, ...props }) => {
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  const handleSetDate = (date) => {
    handleSetAnswer({ target: { value: date } }, item);
  }
  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>
      <div className='content-box d-flex flex-column gap-6'>
        <p className={`heading fs-13 d-flex gap-01 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
          {/* {item.content || '[Enter prompt or question]'} */}
          {ShowItemContent(item, isGroupNote)}
          {/* \\ Required icon commented \\ */}
          {/* {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>} */}
        </p>
        <div className={`input mb-0 w-100 ${validations?.isInvalid ? 'error' : ''}`}>
          <DatePicker
            id="dateInput"
            value={item.answer}
            handleCalendarChangefunc={date => handleSetDate(date)}
            showLabel={false}
          />
          {validations?.isInvalid ?
            <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
              <i className="bi bi-info-circle-fill fs-10"></i>
              <p className="fs-9 text-white text">Date is Required!</p>
            </div> : ''}
        </div>
      </div>
    </div>
  );
};

export default Date